import { Platform } from 'react-native';

export function resolveApiUrl(): string {
  const configuredUrl =
    process.env.EXPO_PUBLIC_API_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://funnel-panel-api-prod.infra.flowsoftdev.com'
      : 'http://localhost:3000');

  if (Platform.OS === 'android' && __DEV__) {
    return configuredUrl.replace('localhost', '10.0.2.2');
  }

  return configuredUrl;
}

export const API_URL = resolveApiUrl();
export const API_VERSION = process.env.EXPO_PUBLIC_API_VERSION || 'v1';
